// extracted by mini-css-extract-plugin
export default {"image":"ConnectionSelect_image__GHj9W","name":"ConnectionSelect_name__ioAkn"};